/*                                                                                             */
/*                                                           */
export var is_array = Array.isArray;
export var array_from = Array.from;
export var object_keys = Object.keys;
export var define_property = Object.defineProperty;
export var get_descriptor = Object.getOwnPropertyDescriptor;
export var get_descriptors = Object.getOwnPropertyDescriptors;
export var object_prototype = Object.prototype;
export var array_prototype = Array.prototype;
export var get_prototype_of = Object.getPrototypeOf;

/**
 *
 *
 */
export function is_function(thing) {
	return typeof thing === 'function';
}

export const noop = () => {};

/*                                                                   */
/*                                                                                   */

/**
 *
 *
 *
 */
export function is_promise(value) {
	return typeof value?.then === 'function';
}

/*                       */
export function run(fn) {
	return fn();
}

/*                                 */
export function run_all(arr) {
	for (var i = 0; i < arr.length; i++) {
		arr[i]();
	}
}

/**
 *
 *
 */
export function deferred() {
	/*                             */
	var resolve;

	/*                                */
	var reject;

	/*                     */
	var promise = new Promise((res, rej) => {
		resolve = res;
		reject = rej;
	});

	/*               */
	return { promise, resolve, reject };
}

/**
 *
 *
 *
 *
 *
 */
export function fallback(value, fallback, lazy = false) {
	return value === undefined
		? lazy
			? /*                  */ (fallback)()
			: /*            */ (fallback)
		: value;
}
